import React, { useEffect } from "react";
import { FaUserPlus, FaUserCheck, FaUserTimes, FaLink, FaTrash, FaFlag } from "react-icons/fa";
import frnds from "../assets/frnds.png";
import ellipse from "../assets/Ellipse 1.png";
import pipaanlogo from "../assets/pipaanlogo.png";
import newsfeed from "../assets/images/icons/newsfeed.png";
import friendsfollowers from "../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../assets/images/icons/groupandfamily.png";
import chats from "../assets/images/icons/chats.png";
import profile from "../assets/images/icons/profile.png";
import Account from "../assets/images/icons/account-setting.png";
import help from "../assets/images/icons/helpandsupport.png";
import logout from "../assets/images/icons/logout.png";
import GroupsList from "../components/nestedtab/GroupsList";
import Verify from "../assets/images/icons/verify.png"
import backtogrp from "../assets/images/icons/backtogrp.png"
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar"; // Import scrollbar styles
import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown } from "react-icons/fa";
import groupimg from "../assets/groupimg.png";
import userimg from "../assets/user.png";
import profileimg from "../assets/profile.png";
import share from "../assets/share.png";
import notification from "../assets/images/icons/notification.png";
import hamburger from "../assets/images/icons/hamburger.png";
import hamburgerclose from "../assets/images/icons/hamburgerclose.png";
import closecircle from "../assets/images/icons/close-circle.png";
import FeedPost from "./feedpost/FeedPost";
import postData from "./feedpost/postdata";
import { Menu, X, Bell, User } from "lucide-react"; // Icons
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import { useState } from "react";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "../components/sidebar/leftsidebar"
import LeftResponsivesidebar from "../components/sidebar/left-responsive"
import Rightsidebar from "../components/sidebar/rightsidebar"
import RightResponsivesidebar from "../components/sidebar/right-responsive"
import Headmenu from "../components/sidebar/headmenu"
import profileData from "./feedpost/profiledata";
import postone from "../assets/images/post-1.png";
import posttwo from "../assets/images/post-2.png";
import postthree from "../assets/images/post-3.png";
// import GroupTabs from "../components/nestedtab/GroupTabs";
import groupone from "../assets/images/group-1.png";
import grouptwo from "../assets/images/group-2.png";
import groupthree from "../assets/images/group-3.png";
import groupfour from "../assets/images/group-4.png";
import Grpaddcircle from "../assets/images/icons/grp-add-circle.png";
import { friendRequests, groupData } from './nestedtab/friendRequestsData';
import { Check } from "lucide-react"; // Icon library for the check mark
import axios from "axios";
import { loadFriendRequests } from "../components/nestedtab/friendRequestsData"; // Import the function to load friend requests
import Adminpanel from "../components/nestedtab/adminpanel";
import Microphone from "../assets/images/icons/microphone.png";
import Smiley from "../assets/images/icons/smiley.png";
import videoicon from "../assets/images/icons/video.png";
import galleryicon from "../assets/images/icons/gallery.png";
import searchicon from "../assets/images/icons/search.png";

const GroupTabs = ({ user,groupData }) => {
  const [activeTab, setActiveTab] = useState("Groupchat"); // Default to Groupchat
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [images, setImages] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  // Filter group data based on user.id
  const selectedGroup = groupData.find((group) => group.id === user?.id);

  useEffect(() => {
    if (user && user.id) {
      console.log(`User ID: ${user.id}`);
    }
  }, [user]);

  // Return early if no group data matches the condition
  if (!selectedGroup) return <p className="text-center text-red-500">No Group Data Found</p>;
  // if (!selectedGroup) {
  //   return <p className="text-center text-red-500">Group not found for the user.</p>;
  // }
  

  // Handle image upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const uploadedImages = files.map((file) => URL.createObjectURL(file));
    setImages([...images, ...uploadedImages]);
  };

  // Handle sending message
  const handleSendMessage = () => {
    if (message.trim() || images.length > 0) {
      const currentTime = new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });

      setMessages([...messages, { text: message, images, time: currentTime }]);
      setMessage('');
      setImages([]);
    }
  };

  return (
    <div className="p-4 bg-gray-100 rounded-2xl shadow-md mx-6 my-6 adminpanel">
      {/* Header with Tab Switching */}
      
      {activeTab === "Groupchat" && (
        <div>
          {/* CHAT HEADER */}
          <div className="chat-header flex items-center p-4 bg-white border-b">
            <img
             src={selectedGroup.group_image}
              alt={selectedGroup.group_name}
              className="w-20 h-20 rounded-[16px] mr-3"
            />

            <div className="flex-1 text-center">
              <h2 className="head text-[#2C2C2E] flex justify-center items-center">
              &#129412; {selectedGroup.group_name}
              </h2>
              <p className="text-[12px] text-[#666668]">
              {selectedGroup.acceptedMembersCount} Members | Created on: {new Date(selectedGroup.created_at).toLocaleDateString()}
              </p>

              <span
                onClick={() => {
                  setActiveTab("Adminpanel");
                  setSelectedUserId(user.id);
                }}
                className="text-[#095228] text-sm cursor-pointer underline"
              >
                View Group Info
              </span>
            </div>
            <div className="hidden md:block">
              <div className="flex items-center bg-[#F3F4F6] px-3 py-4 rounded-full grp-chat-search-field ">
                <img
                  src={searchicon}
                  className="w-auto mr-3"
                />
                <input
                  type="text"
                  placeholder="Find Message"
                  className="ml-2 text-gray-500 outline-none bg-transparent w-full hidden md:block"
                />
              </div>
            </div>
            <div className="sm:hidden">
              <div>
                {/* Toggle Button */}
                <button className="px-3" onClick={() => setShowSearch(!showSearch)}>
                  <img src={searchicon} alt="Video Icon" />
                </button>

                {/* Search Field */}
                {showSearch && (
                  <div className="flex items-center bg-[#F0F0F0] px-3 py-4 rounded-full grp-chat-search-field">
                    <img src={searchicon} className="w-auto searchicon" />
                    <input
                      type="text"
                      placeholder="Find Message"
                      className="ml-2 text-gray-500 outline-none bg-transparent w-full"
                    />
                  </div>
                )}
              </div>

            </div>
          </div>

          {/* CHAT CONTENT AREA */}
          <div className="dashboard w-full min-h-screen flex mx-auto">
            <main className="flex w-full">
              <div className="flex flex-col h-screen w-full">
                <div className="flex-1 p-4 overflow-y-auto space-y-3">
                  {messages.map((msg, index) => (
                    <div key={index} className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                      <div
                        className={` max-w-xs ${index % 2 === 0 ? 'bg-[#F2F2F7] chat-mess-grp-ppl' : 'shadow-md  bg-[#AEE1B5] text-[#095228] chat-mess-user'
                          }`}
                      >
                        {/* Text Message Display */}
                        {msg.text && (
                          <div className="flex flex-col">
                            <p className={`break-words text-left ${index % 2 === 0 ? 'pl-3 pr-9' : 'pl-3 pr-9'
                              }`}>
                              {msg.text}</p>
                            <span className={`text-[10px] text-right mt-1 ${index % 2 === 0 ? 'pr-1' : 'text-[#095228]'
                              }`}>
                              {msg.time}
                            </span>
                          </div>
                        )}

                        {/* Image/Video Display */}
                        {msg.images && (
                          <div className="grid grid-cols-2 gap-1">
                            {msg.images.map((img, imgIndex) => (
                              <div key={imgIndex} className="relative">
                                <img
                                  src={img}
                                  alt={`Uploaded ${imgIndex + 1}`}
                                  className="rounded-lg w-full h-24 object-cover"
                                />
                                <span className="absolute bottom-1 right-1 text-[10px] text-white bg-black bg-opacity-50 px-1 rounded">
                                  {msg.time}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>



                {/* CHAT FOOTER (INPUT AREA) */}



                <div class="flex items-center p-4 relative">

                  <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                    {/* Profile Image Upload */}
                    <label className="relative cursor-pointer">

                      <img
                        src={selectedGroup.profileimg}
                        alt={selectedGroup.groupName}
                        className="w-[80px] h-[70px] rounded-full object-cover "
                      />
                    </label>
                  </div>
                  <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[40px] ">
                    <div class="flex space-x-2 ml-3 py-4 microphone-sm">
                      <button class="text-gray-400"><img
                        src={Microphone}
                        alt={selectedGroup.groupName}
                        className=""
                      /></button>
                    </div>
                    {/* <input
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Add a comment"
                      class="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                    /> */}
                    <input
                      type="text"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSendMessage(); // Trigger the send function on Enter key press
                        }
                      }}
                      className="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                    />
                    <div class="flex space-x-2 ml-3 py-4 chat-media-icon">
                      <button class="px-3 smiley">
                        <img
                          src={Smiley}
                          alt={selectedGroup.groupName}
                          className=""
                        />
                      </button>
                      <label className="cursor-pointer">
                        <img
                          src={galleryicon}
                          alt={selectedGroup.groupName}
                          className=""
                        />
                        <input
                          type="file"
                          multiple
                          accept="image/*"
                          className="hidden"
                          onChange={handleImageUpload}
                        />
                      </label>
                      <button class="px-3">
                        <img
                          src={videoicon}
                          alt={selectedGroup.groupName}
                          className=""
                        />
                      </button>
                    </div>
                    <button onClick={handleSendMessage} class="grp-dashboard-submit-cta text-white px-5 py-3 h-full rounded-[25px] mx-3">Send</button>
                    
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      )}

      {/* Admin Panel */}
      {activeTab === "Adminpanel" && <Adminpanel matchedGroup={selectedGroup} />}

      {/* Back Button for Returning to Groupchat */}
      {activeTab === "Adminpanel" && (
        <div className="p-2 text-center">
          <button
            onClick={() => setActiveTab("Groupchat")}
            className="text-blue-500 text-sm underline"
          >
            Back to Group Chat
          </button>
        </div>
      )}
    </div>
  );
};

const friends = [
  { id: 1, name: "Websters Shivaji", followers: 764, img: ellipse },
  { id: 2, name: "Websters Shivaji", followers: 764, img: ellipse },
  { id: 3, name: "Websters Shivaji", followers: 764, img: ellipse },
];

const user = {
  img: "https://example.com/group-image.jpg",
  name: "Team Unicorns",
  followers: 200,
  followerImages: [
    "https://example.com/follower1.jpg",
    "https://example.com/follower2.jpg",
  ],
};


export default function FriendsPage() {
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [groupImage, setGroupImage] = useState(null);
  const [groupCover, setGroupCover] = useState(null);
  const [groupMembers, setGroupMembers] = useState([]); // Array of user IDs
  const [loading, setLoading] = useState(false); // Loading state for the API call
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [error, setError] = useState(null); // Error state for file upload
  const [searchQuery, setSearchQuery] = useState(""); // Search query for friends
  const [followers, setFollowers] = useState([]); // List of fetched followers
  const [selectedFriends, setSelectedFriends] = useState([]); // Selected friends for the group
  const [hasMore, setHasMore] = useState(true); // To check if more data is available
  const [friendRequests, setFriendRequests] = useState([]);
  const [activeUser, setActiveUser] = useState(null);
  const [showTabs, setShowTabs] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);
  const [groupData, setGroupData] = useState([]); // Store groups from API

  
  useEffect(() => {
    const fetchGroups = async () => {
      setLoading(true);
      const token = sessionStorage.getItem("accessToken");

      try {
        const response = await axios.post(
          "https://pipaan.com360degree.com/api/group/get-groups",
          {
            filters: {
              myAcceptedGroup: true,
            },
            page: 1,
            limit: 50,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: `${token}`,
            },
          }
        );

        if (response.data.success) {
          setGroupData(response.data.result.groups); // Set the groups data
        } else {
          console.error("Failed to fetch groups:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const requests = await loadFriendRequests();
      setFriendRequests(requests);
    };

    fetchData();
  }, []);

  const handleCoverPhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCoverPhoto(URL.createObjectURL(file));
    }
  };


  const handleProfilePhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePhoto(URL.createObjectURL(file));
    }
  };
  const [isPopupOpen, CreatePopupOpen] = useState(false); // 🔹 Popup state
  const createnewgroup = () => {
    CreatePopupOpen(true);
  };
  const closePopup = () => {
    CreatePopupOpen(false);
  };

  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);

  // ✅ Separate function for toggling state
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  const [activeTab, setActiveTab] = useState("Interests");
  const friendsList = [1, 2, 3, 4]; // Replace with actual friends data
  const followersList = [1, 2, 3, 4, 5, 6]; // Replace with actual followers data

  const uploadFiles = async (uploadedMedia) => {
    if (uploadedMedia.length === 0) throw new Error("No files selected for upload");

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type,
    }));

    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/aws/generate-presigned-url",
        { files: fileData },
        {
          headers: {
            token: sessionStorage.getItem("accessToken"),
          },
        }
      );

      if (!response.data.success) {
        throw new Error("Failed to generate pre-signed URLs");
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload media files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              "Content-Type": uploadedMedia[index].file.type,
              "Content-Encoding": "binary",
            },
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );

      // Return the uploaded media URLs
      return preSignedUrls.map((item) => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl,
      }));
    } catch (error) {
      console.error("Upload error:", error);
      throw new Error("Failed to upload files. Please try again.");
    }
  };

  // Handle group image upload
  const handleGroupImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const uploadedMedia = [{ file, type: file.type.startsWith("image/") ? "image" : "video" }];
        const uploadedUrls = await uploadFiles(uploadedMedia);
        setGroupImage(uploadedUrls[0].url); // Set the uploaded URL for the group image
      } catch (error) {
        console.error("Error uploading group image:", error);
        setError("Failed to upload group image. Please try again.");
      }
    }
  };

  // Handle group cover upload
  const handleGroupCoverUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const uploadedMedia = [{ file, type: file.type.startsWith("image/") ? "image" : "video" }];
        const uploadedUrls = await uploadFiles(uploadedMedia);
        setGroupCover(uploadedUrls[0].url); // Set the uploaded URL for the group cover
      } catch (error) {
        console.error("Error uploading group cover:", error);
        setError("Failed to upload group cover. Please try again.");
      }
    }
  };

  const handleCreateGroup = async () => {
    if (!groupName || !groupDescription || !groupImage || !groupCover) {
      alert("Please fill in all the required fields.");
      return;
    }

    setLoading(true); // Set loading state

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/group/add-group",
        {
          group_name: groupName,
          group_image: groupImage,
          group_cover: groupCover,
          description: groupDescription,
          group_members: groupMembers, // Array of user IDs
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("accessToken"),
          },
        }
      );

      if (response.data.success) {
        alert("Group created successfully!");
        // Reset the form
        setGroupName("");
        setGroupDescription("");
        setGroupImage(null);
        setGroupCover(null);
        setGroupMembers([]);
        CreatePopupOpen(false); // Close the popup
      } else {
        console.error("Failed to create group:", response.data.message);
        alert("Failed to create group.");
      }
    } catch (error) {
      console.error("Error creating group:", error);
      alert("An error occurred while creating the group.");
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const fetchFollowers = async (query = "", page = 1) => {
    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken");

    const requestBody = {
      filters: {

        // search: query, // Add search query to filter results
      },
      page: page,
      limit: 10,
    };

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/user/get-all-users",
        requestBody,
        {
          headers: {
            token: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        const newFollowers = response.data.result.users;

        // Append new followers to the existing list
        setFollowers((prev) => (page === 1 ? newFollowers : [...prev, ...newFollowers]));

        // Check if there are more followers to load
        if (newFollowers.length < 10) {
          setHasMore(false); // No more data if fewer than 10 items are returned
        }
      } else {
        setError("Failed to fetch followers.");
      }
    } catch (error) {
      console.error("❌ Error fetching followers:", error);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() !== "") {
      fetchFollowers(query); // Fetch followers matching the query
    } else {
      setFollowers([]); // Clear followers if the query is empty
    }
  };
  const handleFriendSelect = (friend) => {
    if (!selectedFriends.some((f) => f.id === friend.id)) {
      setSelectedFriends((prev) => [...prev, friend]);
      setGroupMembers((prev) => [...prev, friend.id]); // Add friend ID to groupMembers
    }
  };
  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />


      <main className="flex-1 p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        {/* Main Content */}
        <main className="flex ">

          {/* Feeds */}
          <div className="flex-1 space-y-6 sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-1/4">
            <div className="flex  space-x-4 mt-4">
              <div className="slider-md-swiper grp-slider-md-swiper">
                <aside className=" bg-white p-3  ">
                  <div className="">
                    {/* Followers Section */}
                    <h3 className="text-xl font-bold flex items-center">
                      Group Requests
                      <span className="tab-user-count ml-2 text-[#fff] bg-[#095228]">
                        {friendRequests.length}
                      </span>
                    </h3>
                    <Swiper
                      spaceBetween={10}
                      slidesPerView={3}
                      navigation={false}
                      scrollbar={{ hide: false, draggable: true }}
                      modules={[Scrollbar]}
                      breakpoints={{
                        0: { slidesPerView: 1 },   // 📱 Show 1 slide on small screens
                        768: { slidesPerView: 2 }, // 🖥 Show 2 slides on tablets
                        1024: { slidesPerView: 3 } // 💻 Show 3 slides on desktops
                      }}
                      className="relative"
                    >
                      {friendRequests.map((user) => (
                        <SwiperSlide key={user.id}>
                          <div className="swiper-groupsfollowers bg-white flex items-center p-4 my-7 shadow-sm">
                            {/* Group Image */}
                            <img
                              src={user.img}
                              alt={user.name}
                              className="rounded-lg w-16 h-16 object-cover profile-grp"
                            />

                            <div className="flex swiper-groupsfollowers-sm">
                              {/* Group Details */}
                              <div className="ml-4 flex-1">
                                {/* Group Name */}
                                <h4 className="text-lg font-semibold">
                                  <span className="px-1 rounded text-[#000000]">{user.name}</span>
                                </h4>

                                {/* Member Avatars */}
                                <div className="flex items-center mt-1">
                                  <div className="flex -space-x-1">
                                    {(user.followerImages ?? []).slice(0, 4).map((img, index) => (
                                      <img
                                        key={index}
                                        src={img}
                                        alt={`Follower ${index + 1}`}
                                        className="w-6 h-6 rounded-full border-2 border-white"
                                      />
                                    ))}
                                  </div>
                                  <p className="text-sm text-gray-600 mt-1 md:hidden">
                                    {user.followers ?? "0"} Members
                                  </p>
                                </div>

                                {/* Member Count */}
                                <p className="text-sm text-gray-600 mt-1 hidden sm:block">
                                  {user.followers ?? "0"} Members
                                </p>
                              </div>

                              {/* Buttons */}
                              <div className="flex items-center space-x-2 grp-swiper-cta">
                                <button className="bg-[#095228] text-white px-4 py-2 rounded-full">
                                  Accept
                                </button>
                                <button className="border-2 border-[#BE1F2E] text-[#BE1F2E] px-3 py-2 rounded-full flex items-center justify-center w-10 h-10 reject">
                                  <span className="hidden sm:block">✖</span>
                                  <span className="md:hidden">Reject</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </aside>
              </div>
            </div>
            <div >
            </div>

            <div className="feed-tabs profile-page-feeds w-full mx-auto text-center lg:text-left">
              <div className="flex items-center gap-x-6 justify-between">
                <div className="filter bg-[] lg:p-3 flex space-x-4">
                  {["Groups", "Family"].map((tab) => (
                    <button
                      key={tab}
                      className={`lg:p-3 friends-flowers-tab  ${activeTab === tab
                        ? "active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                        : "text-black "
                        } focus:outline-none`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab} <span className="tab-user-count ml-1 text-[#fff] bg-[#095228]">{tab === "Friends" ? friendsList.length : followersList.length}</span>
                    </button>
                  ))}
                </div>
                <div className="w-full flex justify-end hidden md:block text-end">
                  <button class="grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-3 " onClick={createnewgroup}><div className="flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]"><img src={Grpaddcircle} className="w-7 h-6 pr-1" /> <span>Create New Group</span></div></button>
                </div>

              </div>
              {/* Tab Content */}
              <div className="mt-4">
                {activeTab === "Groups" && (
                  //  <GroupsList friendRequests={friendRequests} />
                  <div className="grp-tab-content">
                    {/* Group Tabs (Left Sidebar) */}
                    <div className="grp-tab-content-flex flex items-start text-center">
                      {(showTabs || !isMobile) && (
                        <div className="grop-tab ">
                          <div className="flex relative w-full mt-5">
                            <div className="fasearch">
                              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                            </div>
                            <input
                              type="text"
                              placeholder="Find Your Friend"
                              className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300"
                            />
                          </div>
                          <div className="w-full flex justify-end block md:hidden py-5">
                            <button class="w-full grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-0 " onClick={createnewgroup}><div className="w-full flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]"><img src={Grpaddcircle} className="w-7 h-6 pr-1" /> <span>Create New Group</span></div></button>
                          </div>

                          {isPopupOpen && (
                            <div className="popup-share z-[99999] viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
                              <div className="border-popup bg-white rounded-lg  relative">
                                <div className="flex justify-between">
                                  <div className="logo-popup flex items-center justify-center space-x-2 ">
                                    <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
                                  </div>
                                  {/* Close Button */}
                                  <button className="close-pop-x relative  text-gray-500" onClick={() => CreatePopupOpen(false)}
                                  >                                <img src={closecircle} alt="Pipaan Logo" className="w-10 h-10" />
                                  </button>
                                </div>
                                <div className="max-w-3xl mx-auto p-4 crt-new-grp">
                                  <div className="flex flex-col items-center space-y-4">
                                    {/* Cover Photo */}
                                    <div className="relative pb-[100px]">
                                      <div className="cover-photo-newgrp relative w-[500px] md:w-[750px] h-[200px] bg-green-100 overflow-hidden">
                                        {coverPhoto ? (
                                          <img
                                            src={coverPhoto}
                                            alt="Cover Preview"
                                            className="w-full h-full object-cover"
                                          />
                                        ) : (
                                          <div className="flex justify-center items-center w-full h-full text-gray-500">
                                            Upload Cover Photo
                                          </div>
                                        )}
                                        <input
                                          type="file"
                                          accept="image/*"
                                          className="absolute inset-0 w-full h-auto opacity-0 cursor-pointer"
                                          onChange={handleCoverPhotoChange}
                                        />
                                      </div>

                                      {/* Profile Photo */}
                                      <div className=" top:20px md:right-[auto] absolute top-[130px] left-[30px] w-[150px] h-[150px] bg-green-300 rounded-[42px] overflow-hidden">
                                        {profilePhoto ? (
                                          <img
                                            src={profilePhoto}
                                            alt="Profile Preview"
                                            className="w-full h-full object-cover"
                                          />
                                        ) : (
                                          <div className="flex justify-center items-center w-full h-full text-gray-500">
                                            Upload Profile
                                          </div>
                                        )}
                                        <input
                                          type="file"
                                          accept="image/*"
                                          className="absolute inset-0 w-auto h-auto opacity-0 cursor-pointer"
                                          onChange={handleProfilePhotoChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mb-4 text-left">
                                    <label className="block text-[#000000] font-medium mb-2">Group Name</label>
                                    <input
                                      type="text"
                                      placeholder="Enter Group Name"
                                      className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                  </div>

                                  <div className="mb-4 text-left">
                                    <label className="block text-[#000000] font-medium mb-2">Group Info</label>
                                    <textarea
                                      placeholder="Enter Group Name"
                                      className="w-full border border-[#095228] rounded-[12px] p-4 h-24 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                  </div>
                                  <div className="mb-4 text-left">
                                    <label className="block text-[#000000] font-medium mb-2">Invite Friends</label>
                                    <input
                                      type="text"
                                      placeholder="Invite Friends"
                                      className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                  </div>
                                  <div className=" followers followers-friends-profile followers-responsive justify-between flex-wrap md:flex-nowrap pb-6 border-b border-[#161f283d]">
                                    <div className="flex w-full ">
                                      <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                                      <div className="pl-4 w-full">
                                        <div className="flex items-center justify-between">
                                          <p className="titlesemibold pb-1 pr-5">Marketing Group</p>

                                        </div>
                                        <p className="text-[12px] text-[#747474] pb-1">
                                          @prvnk_sky
                                        </p>
                                        <p className="members">764 Followers <span className="text-[#D9D9D9]">|</span></p>
                                      </div>

                                    </div>
                                    <div className="flex items-center space-x-4 w-full  justify-between  flex-row-reverse  md:flex-row mt-3">
                                      {/* Custom Checkbox */}
                                      <label className="flex items-center space-x-2 cursor-pointer ">
                                        <div
                                          className={`w-4 h-4 border-2 rounded-md flex justify-center items-center transition ${isAdmin ? "border-[#095228] bg-green-100" : "border-gray-400"
                                            }`}
                                          onClick={() => setIsAdmin(!isAdmin)}
                                        >
                                          {isAdmin && <Check size={18} className="text-[#095228]" />}
                                        </div>
                                        <span className="text-[#344054] text-[12px]">Mark as Admin</span>
                                      </label>

                                      <div className="flex follow-unfollow-cta justify-end ">
                                        <button className="follow-cta my-2">Add as Group Member</button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex relative w-full ">
                                    <div className="fasearch">
                                      <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" /></div>
                                    <input
                                      type="text"
                                      placeholder="Find Group Members"
                                      className="search-input focus:outline-none focus:ring-2 focus:ring-[#e5e7eb] bg-[#FFFFFF]"
                                    />
                                  </div>
                                  <div className=" followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 ">
                                    <div className="flex w-full">
                                      <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                                      <div className="pl-4 w-full">
                                        <div className="flex items-center ">
                                          <p className="titlesemibold pb-1 pr-5">Marketing Group</p>
                                          <p className="cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
                                            <img src={Verify} className="w-fit h-fit" />
                                            <span>Admin</span>
                                          </p>
                                        </div>
                                        <p className="text-[12px] text-[#747474] pb-1">
                                          @prvnk_sky
                                        </p>
                                        <p className="members">764 Followers <span className="text-[#D9D9D9]">|</span> <span className="italic text-[#095228b8] text-[10px] underline">4 Mutual Followers</span></p>
                                      </div>

                                    </div>
                                    <div className="flex follow-unfollow-cta justify-end w-full">
                                      <button className="text-[#095228] text-[12px] my-2 bg-[#EBF8ED] rounded-[20px] p-2">Cancle</button>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          )}
                          {friendRequests.map((user) => (
                            <button
                              key={user.id}
                              onClick={() => {
                                setActiveUser(user);
                                if (isMobile) setShowTabs(false); // Hide only on mobile
                              }}
                              className={`tab-id-profile cursor-pointer ${activeUser?.id === user.id ? "" : ""}`}
                            >
                              <div className={`swiper-groupsfollowers bg-white flex items-center p-1 my-7 cursor-pointer ${activeUser?.id === user.id ? "gropfam-border" : ""}`}>
                                <img src={user.img} alt={user.name} className="rounded-lg w-[92px] h-[102px] object-cover" />
                                <div className="ml-4 flex-1 my-3">
                                  <h4 className="text-lg text-left font-semibold">
                                    <span className="px-1 rounded text-[#000000]">{user.name}</span>
                                  </h4>
                                  <div className="flex items-center mt-1 mb-2">
                                    <div className="flex -space-x-1">
                                      {(user.followerImages ?? []).slice(0, 4).map((img, index) => (
                                        <img
                                          key={index}
                                          src={img}
                                          alt={`Follower ${index + 1}`}
                                          className="w-6 h-6 rounded-full border-2 border-white"
                                        />
                                      ))}
                                    </div>
                                    <span className="text-xs text-[#000000] px-2 py-0.5 rounded-full ml-2 followers-user">
                                      {user.followers} Members
                                    </span>
                                  </div>
                                  {activeUser?.id === user.id && (
                                    <p className="cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
                                      <img src={Verify} className="w-fit h-fit" />
                                      <span>You are the Admin</span>
                                    </p>
                                  )}
                                </div>
                              </div>
                            </button>
                          ))}
                        </div>
                      )}

                      {/* CTA to Show Tabs Again */}
                      {!showTabs && isMobile && (
                        <button
                          onClick={() => setShowTabs(true)}
                          className="back-to-grps px-4 py-2 text-[#313131] text-[17px] font-semibold textrounded-lg mt-4 m-auto flex"
                        >
                          <img
                            src={backtogrp}
                            className="w-6 h-5 pr-3"
                          /> <span className="hidden md:block">Back to Groups</span>
                        </button>
                      )}

                      <div className="w-full">
                        {/* {activeUser ? <GroupTabs user={activeUser} /> : <p className="p-4">Select a group to see details.</p>} */}
                        {activeUser ? (
          <GroupTabs user={activeUser} groupData={groupData} />
        ) : (
          <p className="text-center">Select a group to view details.</p>
        )}
          {/* Display group list */}
          {/* <div className="group-list">
          {loading ? (
            <p>Loading groups...</p>
          ) : (
            groupData.map((group) => (
              <div
                key={group.id}
                className="group-item cursor-pointer"
                onClick={() => setActiveUser(group)} // Set active user on click
              >
                <img
                  src={group.group_image}
                  alt={group.group_name}
                  className="w-16 h-16 rounded-full"
                />
                <h3>{group.group_name}</h3>
                <p>{group.description}</p>
              </div>
            ))
          )}
        </div> */}
                      </div>
                    </div>
                  </div>
                  
                  //   <div className="friend-requests">
                  //   {friendRequests.map((request) => (
                  //     <div key={request.id} className="friend-request">
                  //       <img src={request.img} alt={request.name} className="friend-img" />
                  //       <div>
                  //         <h3>{request.name}</h3>
                  //         <p>{request.followers} Followers</p>
                  //       </div>
                  //     </div>
                  //   ))}
                  // </div>
                )}
                {activeTab === "Family" && (
                  <div className="friends-tab">
                    <div className="flex relative w-full">
                      <div className="fasearch">
                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" />
                      </div>
                      <input
                        type="text"
                        placeholder="Find Your Friend"
                        className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300"
                      />
                    </div>
                    <div className="w-full flex justify-end block md:hidden py-5">
                      <button class="w-full grp-crt-new-grp text-[16px] h-full rounded-[25px] mx-0 " onClick={createnewgroup}><div className="w-full flex px-5 py-3 bg-[#ffffff9e] rounded-[25px]"><img src={Grpaddcircle} className="w-7 h-6 pr-1" /> <span>Create New Group</span></div></button>

                    </div>

                    {followersList.map((user, index) => (
                      <div
                        key={index}
                        className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
                      >
                        <div className="flex">
                          <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                          <div className="pl-4">
                            <p className="titlesemibold pb-1">Marketing Group</p>
                            <p className="text-[12px] text-[#747474] pb-1">@prvnk_sky</p>
                            <p className="members">
                              764 Followers <span className="text-[#D9D9D9]">|</span>{" "}

                            </p>
                          </div>
                        </div>
                        <div className="flex follow-unfollow-cta">
                          <button className="follow-cta my-2">Unfollow</button>
                          <button className="follow-cta-block my-2">Block</button>
                        </div>
                      </div>
                    ))}

                  </div>
                )}
              </div>
            </div>
            <div className="md:hidden">
              <p className="text-[#095228] text-[16px] text-center">© 2025 <b>Pipaan</b>. All Rights Reserved</p>
            </div>
          </div>
          {isPopupOpen && (
            <div className="popup-share z-[99999] viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
              <div className="border-popup bg-white rounded-lg  relative">
                <div className="flex justify-between">
                  <div className="logo-popup flex items-center justify-center space-x-2 ">
                    <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
                  </div>
                  {/* Close Button */}
                  <button className="close-pop-x relative  text-gray-500" onClick={() => CreatePopupOpen(false)}
                  >                                <img src={closecircle} alt="Pipaan Logo" className="w-10 h-10" />
                  </button>
                </div>
                <div className="max-w-3xl mx-auto p-4 crt-new-grp">
                  <div className="flex flex-col items-center space-y-4">
                    {/* Cover Photo */}
                    <div className="relative pb-[100px]">
                      <div className="cover-photo-newgrp relative w-[500px] md:w-[750px] h-[200px] bg-green-100 overflow-hidden">
                        {groupCover ? (
                          <img
                            src={groupCover}
                            alt="Cover Preview"
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="flex justify-center items-center w-full h-full text-gray-500">
                            Upload Cover Photo
                          </div>
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          className="absolute inset-0 w-full h-auto opacity-0 cursor-pointer"
                          onChange={handleGroupCoverUpload}
                        />
                      </div>

                      {/* Profile Photo */}
                      <div className=" top:20px md:right-[auto] absolute top-[130px] left-[30px] w-[150px] h-[150px] bg-green-300 rounded-[42px] overflow-hidden">
                        {groupImage ? (
                          <img
                            src={groupImage}
                            alt="Profile Preview"
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="flex justify-center items-center w-full h-full text-gray-500">
                            Upload Profile
                          </div>
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          className="absolute inset-0 w-auto h-auto opacity-0 cursor-pointer"
                          onChange={handleGroupImageUpload}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 text-left">
                    <label className="block text-[#000000] font-medium mb-2">Group Name</label>
                    <input
                      type="text"
                      placeholder="Enter Group Name"
                      className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                      value={groupName}
                      onChange={(e) => setGroupName(e.target.value)}

                    />
                  </div>

                  <div className="mb-4 text-left">
                    <label className="block text-[#000000] font-medium mb-2">Group Info</label>
                    <textarea
                      placeholder="Enter Group Name"
                      className="w-full border border-[#095228] rounded-[12px] p-4 h-24 focus:outline-none focus:ring-2 focus:ring-green-500"
                      value={groupDescription}
                      onChange={(e) => setGroupDescription(e.target.value)}

                    />
                  </div>
                  <div className="mb-4 text-left">
                    <label className="block text-[#000000] font-medium mb-2">Invite Friends</label>
                    <input
                      type="text"
                      placeholder="Invite Friends"
                      className="w-full border border-[#095228] rounded-[12px] p-4 focus:outline-none focus:ring-2 focus:ring-green-500"
                      value={searchQuery}
                      onChange={handleSearchChange} // Trigger search on input change
                      onClick={() => {
                        if (followers.length === 0) fetchFollowers();  // ✅ Fetch only if not already loaded
                      }}
                    />
                    {/* Search Results Dropdown */}
                    {followers.length > 0 && (
                      <div className="bg-white border rounded shadow max-h-40 overflow-auto mt-2">
                        {followers.map((friend) => (
                          <div
                            key={friend.id}
                            className="cursor-pointer hover:bg-gray-100 px-4 py-2 flex items-center"
                          >
                            <img
                              src={friend.profile_picture_url || userimg} // Fallback to default image
                              alt={friend.first_name}
                              className="w-8 h-8 rounded-full mr-3"
                            />
                            <div>
                              <p className="font-medium">{friend.first_name} {friend.last_name}</p>
                              <p className="text-sm text-gray-500">@{friend.username}</p>
                            </div>
                               {/* ✅ Now inside the map, friend is defined */}
        <button
          onClick={() => handleFriendSelect(friend)}
          className="text-sm bg-[#095228] text-white px-3 py-1 rounded-full ml-2 hover:bg-green-700"
        >
          Add As Group Member
        </button>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Selected Friends */}
                    {/* {selectedFriends.length > 0 && (
                      <div className="mt-4">
                        <p className="font-medium mb-2">Selected Friends:</p>
                        <div className="flex flex-wrap gap-2">
                          {selectedFriends.map((friend) => (
                            <div
                              key={friend.id}
                              className="bg-green-100 text-green-700 px-3 py-1 rounded-full flex items-center"
                            >
                              {friend.first_name} {friend.last_name}
                              <button
                                className="ml-2 text-red-500"
                                onClick={() => {
                                  setSelectedFriends((prev) => prev.filter((f) => f.id !== friend.id));
                                  setGroupMembers((prev) => prev.filter((id) => id !== friend.id)); // Remove from group members
                                }}
                              >
                                ✖
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )} */}

                  </div>
                  <div className="followers followers-friends-profile followers-responsive flex flex-col space-y-4 pb-6 border-b border-[#161f283d]">
                  {selectedFriends.map((friend) => (
                      <div key={friend.id} className="flex w-full">
                        <img src={friend.profile_picture_url || userimg} alt="User" className="w-15 h-15 rounded-full" />
                        <div className="pl-4 w-full">
                          <div className="flex items-center justify-between">
                            <p className="titlesemibold pb-1 pr-5">{friend.first_name} {friend.last_name}</p>
                          </div>
                          <p className="text-[12px] text-[#747474] pb-1">@{friend.username}</p>
                          <p className="members">{friend.followers || 0} Followers <span className="text-[#D9D9D9]">|</span></p>
                        </div>
                      </div>
                    ))}


                    <div className="flex items-center space-x-4 w-full  justify-between  flex-row-reverse  md:flex-row mt-3">
                      {/* Custom Checkbox */}
                      {/* <label className="flex items-center space-x-2 cursor-pointer ">
                        <div
                          className={`w-4 h-4 border-2 rounded-md flex justify-center items-center transition ${isAdmin ? "border-[#095228] bg-green-100" : "border-gray-400"
                            }`}
                          onClick={() => setIsAdmin(!isAdmin)}
                        >
                          {isAdmin && <Check size={18} className="text-[#095228]" />}
                        </div>
                        <span className="text-[#344054] text-[12px]">Mark as Admin</span>
                      </label> */}

                      {/* <div className="flex follow-unfollow-cta justify-end ">
                        <button className="follow-cta my-2">Add as Group Member</button>
                      </div> */}
                    </div>
                  </div>
                  <div className="flex relative w-full ">
                    <div className="fasearch">
                      <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" /></div>
                    <input
                      type="text"
                      placeholder="Find Group Members"
                      className="search-input focus:outline-none focus:ring-2 focus:ring-[#e5e7eb] bg-[#FFFFFF]"
                    />
                  </div>
                  {/* <div className=" followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 ">
                    <div className="flex w-full">
                      <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                      <div className="pl-4 w-full">
                        <div className="flex items-center ">
                          <p className="titlesemibold pb-1 pr-5">Marketing Group</p>
                          <p className="cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
                            <img src={Verify} className="w-fit h-fit" />
                            <span>Admin</span>
                          </p>
                        </div>
                        <p className="text-[12px] text-[#747474] pb-1">
                          @prvnk_sky
                        </p>
                        <p className="members">764 Followers <span className="text-[#D9D9D9]">|</span> <span className="italic text-[#095228b8] text-[10px] underline">4 Mutual Followers</span></p>
                      </div>

                    </div>
                    <div className="flex follow-unfollow-cta justify-end w-full">
                      <button className="text-[#095228] text-[12px] my-2 bg-[#EBF8ED] rounded-[20px] p-2">Cancel</button>
                    </div>
                  </div> */}

{selectedFriends.map((friend) => (
  <div
    key={friend.id}
    className="followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 flex flex-wrap md:flex-nowrap"
  >
    <div className="flex w-full">
      <img
        src={friend.profile_picture_url || userimg}
        alt="User"
        className="w-15 h-15 rounded-full"
      />
      <div className="pl-4 w-full">
        <div className="flex items-center ">
          <p className="titlesemibold pb-1 pr-5">
            {friend.first_name} {friend.last_name}
          </p>
          <p className="cursor-pointer text-[10px] text-[#095228] mt-1 flex items-center">
            <img src={Verify} className="w-fit h-fit" />
            <span>Member</span>
          </p>
        </div>
        <p className="text-[12px] text-[#747474] pb-1">@{friend.username}</p>
        <p className="members">
          {friend.followers || 0} Followers{" "}
          <span className="text-[#D9D9D9]">|</span>{" "}
          <span className="italic text-[#095228b8] text-[10px] underline">
            {friend.mutual_followers || 0} Mutual Followers
          </span>
        </p>
      </div>
    </div>
    <div className="flex follow-unfollow-cta justify-end w-full">
      <button
        className="text-[#095228] text-[12px] my-2 bg-[#EBF8ED] rounded-[20px] p-2"
        onClick={() => {
          setSelectedFriends((prev) => prev.filter((f) => f.id !== friend.id));
          setGroupMembers((prev) => prev.filter((id) => id !== friend.id));
        }}
      >
        Remove
      </button>
    </div>
  </div>
))}

                  {/* Create Group Button */}
                  <div className="flex justify-end">
                    <button
                      className="follow-cta my-2 bg-[#095228] text-white px-4 py-2 rounded-full"
                      onClick={handleCreateGroup}
                      disabled={loading}
                    >
                      {loading ? "Creating..." : "Create Group"}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          )}
          {/* Right Sidebar */}
          {/* <Rightsidebar /> */}
        </main>
      </main>
    </div>
  );
}



